<template>
	<div id="header">
		<div class="container overflow">
			<div class="logo">
				<img src="../../assets/img/logo.png" alt="">
				<div class="text">
					<p>大救星救援平台</p>
					<p>DaJiuXing Rescue Platform</p>
				</div>
			</div>
			<div class="nav">
				<a :href="url" target="_blank">回到大救星</a>
				<!-- <a>救援中心</a> -->
				<!-- <a href="http://www.dajiuxing.com.cn/djxwork/#/dowapp" target="_blank">大救星app</a>
				<a href="http://www.dajiuxing.com.cn/djxwork/#/contact" target='_blank'>合作咨询</a> -->
				<router-link to='/'>分销系统</router-link>
			</div>
			<div class="login">
				<router-link to='/login'>大救星分销系统登录</router-link>
			</div>
			
		</div>

	</div>
</template>

<script>
import { getToken } from '@/axios/api.js'
export default{
	data(){
		return {
			url:SEVERS
		}
	},
	methods:{
		getToken(){
			var data={
				token:this.$route.query.sessionId
			}
			getToken(data)
			.then(res => {
				console.log(res)
				if(res.data.code == 0){
					window.localStorage.setItem(
						"token",
						JSON.stringify({
							data: res.data
						})
					);
					this.$router.push({
						path:'/shop'
					})				
				}
			})
			.catch(err => {
				console.log(err)
			})			
		}

	},
	mounted() {
		if(this.$route.query.sessionId) {
			this.getToken()
		}
	}
}	
</script>

<style scoped="scoped">
#header{background: #333;height: 70px;}
.logo{overflow: hidden;padding: 15px 0;float: left;}
.logo img{float: left;height: 40px;}
.logo .text{float: left;color: white;margin-left: 10px;}
.logo .text p:last-child{font-size: 14px;}
.login{float: right;line-height: 70px;}
.login a{color: white;font-size: 14px;color: #00abfa;border:1px solid #00abfa;padding: 5px 10px;border-radius: 3px;}
.nav{height: 70px;float: left;margin-left: 100px;}
.nav a{color: white;line-height: 70px;display: inline-block;padding: 0 30px;font-size: 16px;}
.nav a.router-link-active{background-color: #212123;color: #00abfa;}
.nav a:hover{background-color: #212123;color: #00abfa;}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue